// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"incomplete-collections_routeHeader_39Eoy","addButton":"incomplete-collections_addButton_38coX"};